import { events, segmentTrack } from 'helpers/integrations/SegmentSnippet';

export const trackAuctionAccessStart = () => {
	segmentTrack(events.partialSignupRequest, { aa_option_shown: true, aa_step_seen: 0 });
};

export const trackAuctionAccessError = (error) => {
	segmentTrack(events.auctionAccessError, { aa_error_action: error });
};
